import C from '../../constants';

export const activeUser = (state = {}, action) => {
    switch (action.type) {

        case C.SET_USER :
            return Object.assign({}, state, action.payload);

        default :
            return state;
    }

};


// WEBPACK FOOTER //
// ./src/store/reducers/userReducer.js